import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import importListHelper from '../../../Helpers/importListHelper';

export default class AssignmentSearchParams extends SearchParamsBase {
  initialize() {
    this.AsSassieAsgnId = '';
    this.CuId = '';
    this.EvaluatorId = '';
    this.IsEvaluatorRelatedSearch = false;
    this.AsLgsid = '';
    this.AsCcuid = '';
    this.AsSassieSurveyId = '';
    this.ProjectIdOrName = '';
    this.AsWaveName = '';
    this.UseDateRange = false;
    this.AsEvaluatorCompletedDateStart = dateTimeHelper.firstDayOfTheActualMonth();
    this.AsEvaluatorCompletedDateEnd = dateTimeHelper.lastDayOfTheActualMonth();
    this.AsUninvoiceable = '';
    this.PaidOutsideOfSystem = '';
    this.AsSelf = '';
    this.AsBillClient = '';
    this.AsPayEvaluator = '';
    this.AsLdvid = '';
    this.Invoiced = '';
    this.SelectedStatuses = [];
    this.SelectedFieldworkOfficeIds = '';
    this.SelectedPaymentOfficeIds = [];
    this.AsSassieEvalId = '';
    this.EvaluatorEmail = '';
  }

  static getStatusValues() {
    return [
      { label: 'Created', value: '0', disabled: false },
      { label: 'New', value: '1', disabled: false },
      { label: 'Incomplete', value: '2', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Excluded', value: '5', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static tabsOnTheSearchPanel = [
    { label: 'Linking', id: 'linking', icon: 'fa-solid fa-link' },
    { label: 'General', id: 'general', icon: 'fa-solid fa-database' },
    { label: 'Payments', id: 'payments', icon: 'fa-solid fa-file-invoice-dollar' },
  ];

  static fieldsInSearchBox = [
    {
      fieldName: 'AsSassieAsgnId',
      label: 'Apollo IDs',
      className: 'col-4',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'linking',
    },
    {
      fieldName: 'AsCcuid',
      label: 'Client (Name or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.ClientSelect,
      tab: 'linking',
    },
    {
      fieldName: 'ProjectIdOrName',
      label: "Project (Name or ID or '-' for none)",
      className: 'col-4',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },
    {
      fieldName: 'AsSassieSurveyId',
      label: 'Survey (Name or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.SurveySelect,
      idFilter: (item) => item.AsCcuid,
      tab: 'linking',
    },
    {
      fieldName: 'AsWaveName',
      label: 'Wave (Name or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.WaveSelect,
      idFilter: (item) => item.AsCcuid,
      tab: 'linking',
    },

    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: AssignmentSearchParams.getStatusValues(),
      tab: 'general',
    },
    {
      fieldName: 'AsSassieEvalId',
      label: 'Evaluator Apollo IDs',
      className: 'col-4',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'general',
    },
    {
      fieldName: 'EvaluatorEmail',
      label: 'Evaluator Email',
      className: 'col-4',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    {
      fieldName: 'CuId',
      label: 'Apollo Location ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    {
      fieldName: 'UseDateRange',
      label: 'Use Shop Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
      tab: 'general',
    },
    {
      fieldName: 'AsEvaluatorCompletedDateStart',
      label: 'Shop Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
      tab: 'general',
    },
    {
      fieldName: 'AsEvaluatorCompletedDateEnd',
      label: 'Shop End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
      tab: 'general',
    },
    {
      fieldName: 'SelectedFieldworkOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      tab: 'general',
    },
    {
      fieldName: 'SelectedPaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      tab: 'general',
    },

    {
      fieldName: 'Invoiced',
      label: 'Invoiced',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'AsUninvoiceable',
      label: 'Uninvoiceable',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'PaidOutsideOfSystem',
      label: 'Paid Outside of System',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'AsSelf',
      label: 'Self Assigned',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'AsBillClient',
      label: 'Bill Client',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'AsPayEvaluator',
      label: 'Pay Shopper',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'AssignmentSearchParams';
}
